import styled, { css } from "styled-components";
import { colors } from "../../consts";

import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";
import { TextButton } from "../Buttons/styled";

const DrapAndDropWrapperDisabledStyles = css`
  pointer-events: none;
  opacity: 0.7;
`;

export const DrapAndDropWrapper = styled.form`
  height: 66px;
  width: 100%;
  text-align: center;
  position: relative;

  #input-file-upload {
    display: none;
  }

  ${(props) => props.disabled && DrapAndDropWrapperDisabledStyles}
`;

export const DragFileWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

export const InputFileUploadLabel = styled.label`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: ${(props) =>
    props?.hasError ? `1.6px dashed ${colors.ERROR}` : `1.6px dashed ${colors.RAISIN_50}`};

  background-color: ${(props) => (props?.dragActive ? "rgba(52, 48, 61, 0.1)" : "transparent")};

  transition: background-color 0.2s ease-in;

  ${Paragraph2} {
    font-weight: 700;
  }

  ${TextButton} {
    text-decoration: underline;
  }
`;

export const UploadedFileWrapper = styled(WrapperContainer)`
  background: ${colors.TURQUOISE_20};
  border-radius: 4px;
  padding: 8px;
`;

export const FileName = styled(Paragraph2)`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;

  word-break: break-all;
`;

export const FileInfoWrapper = styled(WrapperContainer)`
  flex-wrap: wrap;

  ${Paragraph2} {
    font-size: 12px;
    line-height: 18px;

    color: ${colors.RAISIN_80};
  }
`;

export const ProgressBarContainer = styled(WrapperContainer)`
  width: 100%;
  height: 4px;
  border-radius: 40px;
  background: ${colors.RAISIN_20};
`;

export const ProgressValue = styled(WrapperContainer)`
  width: ${(props) => (props?.value ? `${props.value}%` : 0)};
  height: 4px;
  border-radius: 40px;
  background: ${colors.TURQUOISE_100};
`;

const ImagePreviewStyles = css`
  align-items: center !important;
`;

export const ContentWrapper = styled(WrapperContainer)`
  ${(props) => props?.hasImagePreview && ImagePreviewStyles};
`;

export const ImagePreviewWrapper = styled(WrapperContainer)`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 4px;

  background: ${colors.WHITE};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const WarningMessage = styled(Paragraph2)`
  font-weight: 500;
`;
